module.exports = __webpack_public_path__ + "img/objective-1@2x.c8991187.jpg";